import { useEffect } from 'react';

type SeoProps = {
  title: string;
  description: string;
  socialDescription?: string;
  url: string;
  imageAlt: string;
};

const SITE_NAME = 'Futureworkhelp';
const IMAGE_URL = 'https://futureworkhelp.net/logo1.webp';

function setMeta(attribute: 'name' | 'property', key: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = content;
}

export const Seo = ({ title, description, socialDescription = description, url, imageAlt }: SeoProps) => {
  useEffect(() => {
    document.title = title;

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', socialDescription);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', SITE_NAME);
    setMeta('property', 'og:image', IMAGE_URL);
    setMeta('property', 'og:image:width', '1200');
    setMeta('property', 'og:image:height', '630');
    setMeta('property', 'og:image:alt', imageAlt);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', socialDescription);
    setMeta('name', 'twitter:image', IMAGE_URL);
    setMeta('name', 'twitter:image:alt', imageAlt);
  }, [description, imageAlt, socialDescription, title, url]);

  return null;
};
